import { PlaylistAddCheck } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { Component } from 'react';

class IconeInclusaoConfirmadaPauta extends Component {
    render() {
        if (!this.props.registro) {
            return null;
        }

        if (this.props.registro.confirmadaInclusaoPauta) {
            return (
                <Tooltip title={<Typography>Inclusão confirmada em pauta/sessão</Typography>}>
                    <PlaylistAddCheck sx={{ fillOpacity: 0.7, cursor: 'default' }} />
                </Tooltip>
            );
        }

        return null;
    }
}

IconeInclusaoConfirmadaPauta.propTypes = {
    registro: PropTypes.object.isRequired
};

export default IconeInclusaoConfirmadaPauta;
